import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, Select, Space, Typography } from 'antd';
import { nativeRequest } from './transport';
import PacingEditor from './PacingEditor';

type Admission = {
  compatible: boolean;
  reasons: Array<{ field: string; detail: string }>;
};
/** Display the authoritative policy and allow mode edits only until publication. */
export default function NativeDefinitionCard({
  sessionId,
  mode,
  readOnly,
}: {
  sessionId: number;
  mode: 'daily' | 'news';
  readOnly: boolean;
}) {
  const [admission, setAdmission] = useState<Admission | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [selected, setSelected] = useState(mode);
  const refresh = async () => {
    try {
      setAdmission(
        await nativeRequest<Admission>(
          `/sessions/${sessionId}/fast-admission/`,
        ),
      );
      setError(null);
    } catch (reason) {
      setError(String(reason));
    }
  };
  useEffect(() => {
    void refresh();
  }, [sessionId]);
  const changeMode = async (value: 'daily' | 'news') => {
    try {
      await nativeRequest(
        `/sessions/${sessionId}/update-fast-advancement-mode/`,
        { fast_advancement_mode: value },
      );
      setSelected(value);
      await refresh();
    } catch (reason) {
      setError(String(reason));
    }
  };
  return (
    <Card title="Native historical engine" style={{ marginBottom: 16 }}>
      <Space wrap>
        <Typography.Text>
          Engine fixed when this blueprint was created
        </Typography.Text>
        <Select
          value={selected}
          disabled={readOnly}
          onChange={changeMode}
          options={[
            { value: 'daily', label: 'Daily advancement' },
            { value: 'news', label: 'News landings' },
          ]}
        />
        <Button onClick={() => void refresh()}>Check compatibility</Button>
      </Space>
      <Typography.Paragraph>
        Historical cash portfolios support Classic (0) and Markets V5 (4).
        Select the player view in Tools. V5 includes convictions and news assignments;
        grading is deferred. Existing fast-engine asset, calendar and setting requirements still apply.
      </Typography.Paragraph>
      {error && <Alert type="error" message={error} />}
      {admission && (
        <Alert
          type={admission.compatible ? 'success' : 'warning'}
          message={
            admission.compatible
              ? 'Compatible definition'
              : 'Complete or correct this definition before publishing'
          }
          description={admission.reasons.map((r, i) => (
            <div key={i}>
              {r.field}: {r.detail}
            </div>
          ))}
        />
      )}
      <PacingEditor
        sessionId={sessionId}
        readOnly={readOnly}
        daily={selected === 'daily'}
      />
    </Card>
  );
}
